import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';
import { AppShell } from '../Admin/shell/AppShell';

const VENDEDOR_PEI_GROUPS = [
    {
        label: 'Operación',
        items: [
            { path: '/vendedor/dashboard', label: 'Cotizaciones', icon: 'pi pi-file' },
        ],
    },
];

const VENDEDOR_TRIM_GROUPS = [
    {
        label: 'Operación',
        items: [
            { path: '/vendedor/dashboard', label: 'Trim Pool', icon: 'pi pi-file' },
        ],
    },
];

const ROUTE_TITLES = {
    dashboard: 'Dashboard',
};

export const VendedorShell = () => {
    const { authInfo } = useContext(AuthContext);
    const typeUser = String(authInfo?.user?.type_user ?? '');
    const groups = typeUser === '4' ? VENDEDOR_TRIM_GROUPS : VENDEDOR_PEI_GROUPS;

    return (
        <AppShell
            navGroups={groups}
            allowedTypes={['2', '4']}
            routeTitles={ROUTE_TITLES}
        />
    );
};

export default VendedorShell;
